var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97 422 c-14 -16 -17 -44 -17 -184 0 -147 2 -167 18 -181 26 -24 312 -25 312 -2 0 13 -23 15 -144 15 -86 0 -147 4 -151 10 -4 6 47 10 144 10 l151 0 0 158 c0 203 9 192 -167 192 -113 0 -132 -2 -146 -18z m177 -84 c8 -14 7 -21 -6 -34 -30 -30 -75 9 -48 42 16 18 39 15 54 -8z m36 -112 c0 -34 -25 -56 -65 -56 -40 0 -65 22 -65 56 0 23 3 24 65 24 62 0 65 -1 65 -24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.8454f95ec4402ab974a92e0b633dcf08.svg";
export { ForwardRef as ReactComponent };